import React, { FC, useState, ChangeEvent, MouseEvent } from "react";
import cls from "./customFooter.module.scss";
import useSubscription from "../../../../hooks/useSubscription";
import CustomTextField from "../../../../atoms/CWV/CustomTextField";
import { generateTranslateKey } from "../../../../services/utils";

interface Props {
    translationsData: any;
    showSubscriptionStyle: "block" | "none";
}

const SubscriptionForm: FC<Props> = ({ translationsData, showSubscriptionStyle }) => {
    const [email, setEmail] = useState("");
    const {message = "", messageClass = "", subscribe} = useSubscription();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        subscribe(email);
    };

    return (
        <div className={cls["newsletter-block"]}
             style={{display: showSubscriptionStyle}}
        >
            <div className={cls["footer-newsletter-container"]}>
                <h3 className={cls["footer-newsletter__title"]}>
                    {translationsData?.Subscribe}
                </h3>
                <form className={cls["footer-newsletter__form"]}>
                    <CustomTextField
                        className={cls.custom_input_field}
                        id="footer_news_email__id"
                        type="email"
                        name="email"
                        autoComplete="off"
                        value={email}
                        onChange={handleChange}
                        placeholder={translationsData?.Email}
                    />
                    {!!message && (
                        <small id="passwordHelp" className={messageClass}>
                            {translationsData?.[generateTranslateKey(message)]}
                        </small>
                    )}
                    <div className="btn-wrapper">
                        <button
                            onClick={handleClick}
                            type="submit"
                            className={`${cls["footer-newsletter__form-button"]} btn`}
                        >
                            {translationsData?.SubscribeButton}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SubscriptionForm;